import { AlgorithmTargetRuleType } from '../../../../dataobject/types';
import {
  AlgorithmTargetFormDataType,
  AlgorithmTargetRuleFormDataType,
} from './types';
export const defaultTargetFormData: AlgorithmTargetFormDataType = {
  id: -1,
  algorithmId: -1,
  condition: '',
  description: '',
  sequenceNumber: undefined,
  targetKey: '',
  rules: [],
};

export const defaultTargetRuleFormData: AlgorithmTargetRuleFormDataType = {
  id: -1,
  ruleType: AlgorithmTargetRuleType.RULE,
  ruleCode: '',
  sourceItemCode: '',
  sourceItem: '',
  subjectFieldCodeId: undefined,
  expression: '',
  algorithmTargetId: undefined,
  algorithmId: undefined,
  algorithmSourceId: undefined,
  algorithmSource: undefined,
  algorithmMappingId: undefined,
  dimensionIndicators: [],
  items: [],
};

export function createDefaultTargetFormData(
  algorithmId: number,
  sequenceNumber: number
): AlgorithmTargetFormDataType {
  return {
    ...defaultTargetFormData,
    algorithmId,
    sequenceNumber,
  };
}

export function createDefaultTargetRuleFormData(
  ruleType: AlgorithmTargetRuleType,
  ruleCode: string
): AlgorithmTargetRuleFormDataType {
  return {
    ...defaultTargetRuleFormData,
    ruleType,
    ruleCode,
  };
}
